import { CREATE, ReferenceArrayInput, required, TextInput, UPDATE, useRecordContext } from 'react-admin'

import BasicFormToolbar from '../../components/BasicFormToolbar'
import GroupMembersInput from '../../components/GroupMembersInput'
import { FormDivider } from '../common'
import { AdvancedSimpleForm } from '../common/forms'

export const transformValues = ({ name, description, vehicle_ids, user_group_ids }) => ({
  name,
  description,
  vehicle_ids,
  user_group_ids,
})

const VehicleGroupFormLayout = ({ type = UPDATE, defaultValues, children }) => {
  const record = useRecordContext()
  return (
    <AdvancedSimpleForm toolbar={<BasicFormToolbar formType={type} />} type={type} defaultValues={defaultValues}>
      <TextInput
        source="name"
        validate={required()}
        readOnly={type === UPDATE && record?.is_default}
        helperText={type === CREATE ? 'resources.vehicle-groups.forms.create.nameExample' : undefined}
      />
      <TextInput
        source="description"
        validate={required()}
        helperText={type === CREATE ? 'resources.vehicle-groups.forms.create.descriptionExample' : undefined}
      />
      <FormDivider />
      <GroupMembersInput source="vehicle_ids" reference="vehicles" />
      <FormDivider />
      <ReferenceArrayInput reference={'user-groups'} source="user_group_ids" />
      {children}
    </AdvancedSimpleForm>
  )
}

export default VehicleGroupFormLayout
